<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
            <div class="newtext">新手指引</div>
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../../assets/images/pop/tjlb/tjlb1.jpg" class="steps step1" v-if="status==1">
            <img src="../../../assets/images/pop/tjlb/tjlb2.jpg" class="steps step2" v-if="status==2" >
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"下一步":status==2?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
        <!--        <breadcrumb :routerList="[{to:'/pricenewN',title:'特价管理'},{title:'特价列表'}]"/>-->
        <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox zhi">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">

                        <div class="h-thirdColumn w-newColumn">

                            <el-form-item label="年月" prop="month">
                                <div class="block">
                                    <el-date-picker
                                            v-model="formInline.month"
                                            type="month"
                                            placeholder="选择月"
                                            value-format="yyyy-MM">
                                    </el-date-picker>
                                </div>
                            </el-form-item>

                            <el-form-item label="渠道" prop="fieldChannel">
                                <brselect category="sales_region_ct" :v="formInline.fieldChannel" :clearable="true"
                                          v-model="formInline.fieldChannel" style="width:100%"></brselect>
                            </el-form-item>

                            <el-form-item label="区域" prop="soldToAreaCode">
                                <brselect category="YLRegion" :v="formInline.soldToAreaCode" v-model="formInline.soldToAreaCode"
                                          :multiple="true"
                                          :clearable="true"
                                          style="width:100%"/>
                            </el-form-item>

                        </div>
<!--                        <el-collapse-transition>-->
<!--                            <div v-show="isScreen">-->
<!--                                <div class="h-thirdColumn w-newColumn">-->
<!--                                    <el-form-item label="渠道" prop="customerChannelCode">-->
<!--                                        <brselect category="sales_region" :v="formInline.customerChannelCode" :showcode="true"-->
<!--                                                  v-model="formInline.customerChannelCode" clearable></brselect>-->
<!--                                    </el-form-item>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </el-collapse-transition>-->
                    </el-form>
                    <div class="l-screenBox">
<!--                        <div class="l-screen" @click="collapseChange">
                            <img :src="isScreen?closeScreen:drawScreen" alt="">
                            <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                        </div>-->
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-row T-jia">
                <div class="h-rowIn" style="width:100%;">
<!--                    <div>
                        <div v-if="sysFlag" style="color: #616467;font-size: 15px;">高科累计已使用：{{sysljysy}}</div>
                        <div v-if="zyFlag" style="color: #616467;font-size: 15px;">制药累计已使用：{{zyljysy}}</div>
                        <div v-if="zhyyFlag" style="color: #616467;font-size: 15px;">医疗累计已使用：{{zhyyljysy}}</div>
                        <div v-if="jkFlag" style="color: #616467;font-size: 15px;">疾控累计已使用：{{jkljysy}}</div>
                        <div v-if="xzFlag" style="color: #616467;font-size: 15px;">血站累计已使用：{{xzljysy}}</div>
                    </div>-->
                    <div v-for="(listIt, index) in detailList" :key="index" class="h-formBox">
                        <div style="color: #616467;font-size: 15px;">{{detailList[index].channelName}}累计已使用：{{detailList[index].occupyAreaPrice}}</div>
                        <div style="color: #616467;font-size: 15px;">{{detailList[index].channelName}}预借累计已使用：{{detailList[index].occupyPtPrice}}</div>
                    </div>
                    <el-table
                            ref="multipleTable"
                            :data="tableData2"
                            border
                            stripe
                            max-height="450"
                    >
                        <el-table-column
                                type="selection"
                                width="45"
                                label="全选"
                                fixed
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="50"
                                fixed
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="category"
                                label="特价类型"
                                :show-overflow-tooltip="true"
                                width="150"
                        >
                            <template slot-scope="scope" >
                                {{scope.row.category|dictname('category_tejia')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="fieldChannel"
                                label="渠道"
                                :show-overflow-tooltip="true"
                                width="150"
                        >
                            <template slot-scope="scope" >
                                {{scope.row.fieldChannel|dictname('sales_region_ct')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="soldToAreaName"
                                label="区域"
                                :show-overflow-tooltip="true"
                                width="140"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.soldToAreaName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proModelName"
                                label="产品大类"
                                :show-overflow-tooltip="true"
                                width="150"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.proModelName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="monthOcMoney"
                                label="区域月累计使用额度"
                                :show-overflow-tooltip="true"
                                width="150"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.monthOcMoney}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="monthAdMoney"
                                label="预借本部月累计使用额度"
                                :show-overflow-tooltip="true"
                                width="150"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.monthAdMoney}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="monthMoney"
                                label="合计月累计使用额度"
                                :show-overflow-tooltip="true"
                                width="150"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.monthMoney}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="yearOcMoney"
                                label="区域年累计使用额度"
                                :show-overflow-tooltip="true"
                                width="150"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.yearOcMoney}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="yearAdMoney"
                                label="预借本部年累计使用额度"
                                :show-overflow-tooltip="true"
                                width="150"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.yearAdMoney}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="yearMoney"
                                label="合计年累计使用额度"
                                :show-overflow-tooltip="true"
                                width="150"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.yearMoney}}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="h-tableB h-mrt30" style="padding-right: 0.12rem;">
                <div class="h-tableBL" v-auth="'plldan'">
                    <!--                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>-->
<!--                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                               @click="uploaddownexcelflagbtn">批量导入
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                    <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag"
                                     clsname="orderResourcePoolExcel"
                                     :startrow="1" @callback="uploadExcelFilecallback"/>-->
                </div>
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="query"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
    import updownfile from '../../../utils/updownfile'
    export default {
        components: {
            uploaddownexcel,
            updownfile,
        },
        data() {
            return {
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                tableData2:[],
                formInline: {
                    field:null,//领域
                    daquCode:null,//大区
                    categorys:null,//特价类型
                    fieldChannel:null,//渠道
                    month:null,
                    year:null,
                    soldToAreaCode:null,//区域
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                up:{
                    id: null,
                    field: null,
                    specialCategory: null,
                    year: null,
                    month: null,
                    importMoney: null,
                },
                uploaddownexcelflag:false,
                showOrhide:false,
                updateVisDialogFlag:false,
                uptitleDig: null,
                isScreen: false,
                sysdyed:0,
                sysljed:0,
                sysljysy:0,
                syssyky:0,
                zydyed:0,
                zyljed:0,
                zyljysy:0,
                zysyky:0,
                zhyydyed:0,
                zhyyljed:0,
                zhyyljysy:0,
                zhyysyky:0,
                jkdyed:0,
                jkljed:0,
                jkljysy:0,
                jksyky:0,
                xzdyed:0,
                xzljed:0,
                xzljysy:0,
                xzsyky:0,
                zyFlag:false,
                sysFlag:false,
                zhyyFlag:false,
                jkFlag:false,
                xzFlag:false,
                authCode:null,
                detailList:[],
            }
        },
        //加载页面默认执行
        created() {
            this.query();
            // this.getUserAuth();
        },
        mounted() {

        },
        methods: {
            /*// 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },*/
            showzhezhao(){
                ss.salesList.toshow(this.toshow).then(rd => {
                    console.log(rd)
                    if(rd == false){
                        this.showOrhide = false;
                    }else{
                        this.showOrhide = true;
                    }
                })
            },
            //重置
            resetData(){
                this.formInline.categorys = null;
                this.formInline.field = null;
                this.formInline.daquCode = null;
                this.formInline.soldToAreaCode = null;
                this.formInline.customerChannelCode = null;
                this.formInline.year = null;
                this.formInline.month = null;
            },
            //检索
            query(){
                ss.resourcePool.selectTotalPage(this.formInline).then(rd => {
                    this.tableData2 = rd.records;
                    this.formInline.total = rd.total;
                })
                this.getResourceData();
            },
            //明细导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/resourcePool/downloadExcel",this.formInline,"post",'data');
            },
            dateFormatter(){
                var now = new Date();
                var year=now.getFullYear();
                var month = now.getMonth()+1 < 10?'0'+(now.getMonth()+1) : now.getMonth()+1;
                var alldata2 =  year+"-"+month;
            },
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null || data == '') {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
            // 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },
            //检索
            handleFilter() {
                this.formInline.pageNo = 1;
                this.query();
            },
            //获取表头信息
            getResourceData(v){
                var data = {};
                data.specialCategory = this.formInline.categorys;
                data.month = this.formInline.month;
                ss.resourcePool.getTotalResourceData(data).then(rd => {
                    if(rd.f){
                        this.detailList= rd.msg;
                    }
                })
            },
            //获取表头信息
            getUserAuth(){
                if(this.$store.getters.hasRole('swyl_resource_pool_de') || this.$store.getters.hasRole('swyl_resource_pool')){
                    var data = {};
                    data.usercode = this._user.usercode;
                    data.type = 16;
                    ss.resourcePool.getAuthByCode(data).then(rd => {
                        console.log(rd.msg)
                        if(rd.f){
                            var list = rd.msg;
                            this.sysFlag = false;
                            this.zyFlag = false;
                            this.zhyyFlag = false;
                            this.jkFlag = false;
                            this.xzFlag = false;
                            for(var i = 0;i<list.length;i++){
                                var data = list[i];
                                if(data.code == 'ALL'){
                                    this.zyFlag = true;
                                    this.sysFlag = true;
                                    this.zhyyFlag = true;
                                    this.jkFlag = true;
                                    this.xzFlag = true;
                                    this.getResourceData(1);
                                    this.getResourceData(2);
                                    this.getResourceData(3);
                                    this.getResourceData(4);
                                    this.getResourceData(5);
                                }else {
                                    if(data.code == 1){
                                        this.sysFlag = true;
                                    }else if(data.code == 2){
                                        this.zyFlag = true;
                                    }else if(data.code == 3){
                                        this.zhyyFlag = true;
                                    }else if(data.code == 4){
                                        this.jkFlag = true;
                                    }else if(data.code == 5){
                                        this.xzFlag = true;
                                    }
                                    this.getResourceData(data.code);
                                }
                            }
                            this.authCode = rd.msg.code;
                        }
                    })
                }else {
                    this.zyFlag = true;
                    this.sysFlag = true;
                    this.zhyyFlag = true;
                    this.jkFlag = true;
                    this.xzFlag = true;
                    this.getResourceData(1);
                    this.getResourceData(2);
                    this.getResourceData(3);
                    this.getResourceData(4);
                    this.getResourceData(5);
                }

            }
        }
    }
</script>
<style scoped>
    .selectorBox {
        width: 100%;
        padding: 0.54rem 0.28rem 0 0.25rem;
    }
    .selectorBox .text {
        margin-left: 0.38rem;
        font-size: 0.18rem;
        color: #4a4a4a;
        position: relative;
    }
    .selectorBox .text::before {
        content: "*";
        position: absolute;
        top: 0;
        left: -7px;
        color: red;
        font-size: 0.2rem;
    }
    .selectorBox .selector {
        margin-left: 0.38rem;
        margin-top: 20px;
        display: flex;
    }
    .selectorBox .selector .button {
        width: 65px;
        padding: 10px;
        color: #b7b7b7;
        border: 1px solid #dcdfe1;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
    }
    .selectorBox .selector .button.active {
        color: #fff;
        background: #238cfd;
        border: 1px solid #238cfd;
    }
    .T-jia .h-btn.el-button.h-tableLink{
        padding: 0 0.05rem;
    }
    #xcv {
        padding: 0.14rem 0.2rem;
        font-size: 0.18rem;
        color: #fff;
        letter-spacing: 0.02rem;
        border: 1px solid #24b5b8;
        background: #24b5b8;
        border-radius: 0.04rem;
        line-height: 0.18rem;
    }
</style>
<style>
    .X-la .h-formbLine .el-form-item__content .el-select{
        width: 100%!important;
    }
    .zhi .el-date-editor .el-range-separator{
        width:13%;
        margin-bottom:7px;
    }
    .selectorBox .el-input-group__append {
        background: #238cfd;
        color: #fff
    }
    .selectorBox .el-upload-list {
        display: none;
    }

</style>
<style scoped lang="scss">
    .bottomTip{
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
        z-index: 999999;
    }
    .newtext{
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top:0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow:1px 1px 4px #2785E7;
        z-index: 2;
    }
    .leaderBox{
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;
        .leaderbg{
            width: 100%;
            height: 100%;

        }
        .steps{
            position: absolute;
            z-index: 1;

        }
        .step1{
            top: 0;
            left: 0;

        }
        .step2{
            top: 0;
            right: 0;
        }
        .stepbtn{
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0,0,0,0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }
        .closeIt{
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
            z-index: 2;
        }
    }
</style>
